/**
 * The type we can receive from Postgres
 */
export enum STAKEHOLDER_TYPE {
  NOTSET = 'NOTSET',
  CITIZENS = 'CITIZENS',
  PROPERTY_OWNERS = 'PROPERTY_OWNERS',
  HEALTHCARE_PROVIDERS = 'HEALTHCARE_PROVIDERS',
  CITY_COUNCIL = 'CITY_COUNCIL',
  UTILITIES = 'UTILITIES',
}

/**
 * The type we allow on post/put/patch to Postgres
 */
export type STAKEHOLDER_TYPE_ALLOWED = Exclude<STAKEHOLDER_TYPE, STAKEHOLDER_TYPE.NOTSET>;

/**
 * The type we can receive from Cosmos
 */
export enum STAKEHOLDER_TYPE_CAMEL_CASE {
  NOTSET = 'notSet',
  CITIZENS = 'citizens',
  PROPERTY_OWNERS = 'propertyOwners',
  HEALTHCARE_PROVIDERS = 'healthcareProviders',
  CITY_COUNCIL = 'cityCouncil',
  UTILITIES = 'utilities',
}

/**
 * The type we allow on post/put/patch to Cosmos
 */
export type STAKEHOLDER_TYPE_ALLOWED_CAMEL_CASE = Exclude<
  STAKEHOLDER_TYPE_CAMEL_CASE,
  STAKEHOLDER_TYPE_CAMEL_CASE.NOTSET
>;
